import axios from "axios";
import { takeLatest, put } from "redux-saga/effects";
import { API_BASE_URI } from "../ApiCall";
import { EvmDashboardActionTypes } from "./EvmDashboard.type";

export function* fetchEvmDashboard(action: any): any {
  try {
    const response = yield axios.get(
      `${API_BASE_URI}/evm-dashboard?project_id=${action.payload}`
    );
    yield put({
      type: EvmDashboardActionTypes.FETCH_EVM_DASHBOARD_SUCCESS,
      payload: response.data,
    });
  } catch (error: any) {
    console.error("[EVM] fetch failed:", error?.message || error);
    yield put({
      type: EvmDashboardActionTypes.FETCH_EVM_DASHBOARD_FAILURE,
      payload: error,
    });
  }
}

export function* watcherFetchEvmDashboard() {
  yield takeLatest(EvmDashboardActionTypes.FETCH_EVM_DASHBOARD, fetchEvmDashboard);
}
